const mainSidebarMenu = [
  {
    id: 1,
    path: '/',
    name: 'Dashboard',
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M4 6C4 4.89543 4.89543 4 6 4H11V14H4V6Z" fill="#3e914a" />
        <path
          opacity="0.5"
          d="M13 10H20V18C20 19.1046 19.1046 20 18 20H13V10Z"
          fill="#3e914a"
        />
        <path
          opacity="0.5"
          d="M13 4H18C19.1046 4 20 4.89543 20 6V8H13V4Z"
          fill="#3e914a"
        />
        <path
          opacity="0.5"
          d="M4 16H11V20H6C4.89543 20 4 19.1046 4 18V16Z"
          fill="#3e914a"
        />
      </svg>
    ),
    isMobileOnly: false,
  },
  {
    id: 2,
    path: '/properties',
    name: 'Properties',
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21 7H3C2.4 7 2 6.6 2 6V4C2 3.4 2.4 3 3 3H21C21.6 3 22 3.4 22 4V6C22 6.6 21.6 7 21 7Z"
          fill="#3e914a"
        />
        <path
          opacity="0.3"
          d="M21 14H3C2.4 14 2 13.6 2 13V11C2 10.4 2.4 10 3 10H21C21.6 10 22 10.4 22 11V13C22 13.6 21.6 14 21 14ZM22 20V18C22 17.4 21.6 17 21 17H3C2.4 17 2 17.4 2 18V20C2 20.6 2.4 21 3 21H21C21.6 21 22 20.6 22 20Z"
          fill="#3e914a"
        />
      </svg>
    ),
    isMobileOnly: false,
    childs: [
      { path: '/properties/live', name: 'Live Properties' },
      { path: '/properties/sold', name: 'Sold Properties' },
    ],
  },
  {
    id: 3,
    path: '/analytics',
    name: 'Analytics',
    icon: (
      <svg
        width="24"
        height="14"
        viewBox="0 0 22 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.3 1.60003C20.521 1.76571 20.5657 2.07912 20.4 2.30003L15.0918 9.37762C14.5442 10.1079 13.4766 10.1837 12.8312 9.53828L8.4812 5.18829C8.26272 4.96982 7.90036 4.99981 7.72078 5.25123L3.40691 11.2906C3.2464 11.5154 2.93413 11.5674 2.70942 11.4069C2.48471 11.2464 2.43267 10.9341 2.59317 10.7094L6.90704 4.66999C7.4458 3.91573 8.53288 3.82576 9.1883 4.48119L13.5383 8.83118C13.7534 9.04633 14.1093 9.02104 14.2918 8.77762L19.6 1.70003C19.7657 1.47912 20.0791 1.43434 20.3 1.60003Z"
          fill="#3e914a"
        />
        <rect y="10" width="4" height="4" rx="2" fill="#3e914a" />
        <rect x="6" y="2" width="4" height="4" rx="2" fill="#3e914a" />
        <rect x="18" width="4" height="4" rx="2" fill="#3e914a" />
        <rect x="12" y="8" width="4" height="4" rx="2" fill="#3e914a" />
      </svg>
    ),
    isMobileOnly: false,
  },
  {
    id: 4,
    path: '/crm',
    name: 'CRM',
    icon: (
      <svg
        width="24"
        height="18"
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9 0C4.032 0 0 4.032 0 9C0 13.968 4.032 18 9 18C13.968 18 18 13.968 18 9C18 4.032 13.968 0 9 0ZM3.465 13.599C4.077 13.113 5.508 12.6 6.759 12.6C6.822 12.6 6.894 12.609 6.966 12.609C7.182 12.033 7.569 11.448 8.136 10.935C7.632 10.845 7.155 10.791 6.759 10.791C5.589 10.791 3.708 11.196 2.502 12.078C2.052 11.142 1.8 10.098 1.8 8.991C1.8 5.022 5.031 1.791 9 1.791C12.969 1.791 16.2 5.022 16.2 8.991C16.2 10.071 15.957 11.097 15.525 12.024C14.625 11.493 13.401 11.241 12.609 11.241C11.241 11.241 8.559 11.97 8.559 13.671V16.173C6.516 16.056 4.698 15.084 3.465 13.599Z"
          fill="#3e914a"
        />
        <rect
          opacity="0.5"
          x="4"
          y="5"
          width="5"
          height="5"
          rx="2.5"
          fill="#3e914a"
        />
        <rect
          opacity="0.5"
          x="11"
          y="7"
          width="3"
          height="3"
          rx="1.5"
          fill="#3e914a"
        />
      </svg>
    ),
    isMobileOnly: false,
    childs: [
      { path: '/crm/leads', name: 'Leads' },
      { path: '/crm/customers', name: 'Contacts' },
    ],
  },
  {
    id: 5,
    path: '/newsletters',
    name: 'Newsletters',
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.3"
          d="M21 19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19Z"
          fill="#3e914a"
        />
        <path
          d="M21 5H2.99999C2.69999 5 2.49999 5.10005 2.29999 5.30005L11.2 13.3C11.7 13.7 12.4 13.7 12.8 13.3L21.7 5.30005C21.5 5.10005 21.3 5 21 5Z"
          fill="#3e914a"
        />
      </svg>
    ),
    isMobileOnly: false,
  },
  {
    id: 6,
    path: '/text-messages',
    name: 'Text Messages',
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.3"
          d="M8 8C8 7.4 8.4 7 9 7H16V3C16 2.4 15.6 2 15 2H3C2.4 2 2 2.4 2 3V13C2 13.6 2.4 14 3 14H5V16.1C5 16.8 5.79999 17.1 6.29999 16.6L8 14.9V8Z"
          fill="#3e914a"
        />
        <path
          d="M22 8V18C22 18.6 21.6 19 21 19H19V21.1C19 21.8 18.2 22.1 17.7 21.6L15 18.9H9C8.4 18.9 8 18.5 8 17.9V7.90002C8 7.30002 8.4 6.90002 9 6.90002H21C21.6 7.00002 22 7.4 22 8ZM19 11C19 10.4 18.6 10 18 10H12C11.4 10 11 10.4 11 11C11 11.6 11.4 12 12 12H18C18.6 12 19 11.6 19 11ZM17 15C17 14.4 16.6 14 16 14H12C11.4 14 11 14.4 11 15C11 15.6 11.4 16 12 16H16C16.6 16 17 15.6 17 15Z"
          fill="#3e914a"
        />
      </svg>
    ),
    isMobileOnly: false,
  },
  {
    id: 7,
    path: '/settings',
    name: 'Settings',
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.8766 12.882C18.9136 12.594 18.9414 12.306 18.9414 12C18.9414 11.694 18.9136 11.406 18.8766 11.118L20.8289 9.633C21.0047 9.498 21.051 9.255 20.9399 9.057L19.0894 5.943C19.0062 5.799 18.8489 5.718 18.6823 5.718C18.6268 5.718 18.5713 5.727 18.525 5.745L16.2212 6.645C15.74 6.285 15.2219 5.988 14.6575 5.763L14.3059 3.378C14.2782 3.162 14.0839 3 13.8525 3H10.1515C9.92024 3 9.72593 3.162 9.69818 3.378L9.34658 5.763C8.78218 5.988 8.26404 6.294 7.78291 6.645L5.47905 5.745C5.42353 5.727 5.36802 5.718 5.3125 5.718C5.15521 5.718 4.99792 5.799 4.91464 5.943L3.06415 9.057C2.94387 9.255 2.99938 9.498 3.17518 9.633L5.12745 11.118C5.09044 11.406 5.06268 11.703 5.06268 12C5.06268 12.297 5.09044 12.594 5.12745 12.882L3.17518 14.367C2.99938 14.502 2.95312 14.745 3.06415 14.943L4.91464 18.057C4.99792 18.201 5.15521 18.282 5.32175 18.282C5.37727 18.282 5.43278 18.273 5.47905 18.255L7.78291 17.355C8.26404 17.715 8.78218 18.012 9.34658 18.237L9.69818 20.622C9.72593 20.838 9.92024 21 10.1515 21H13.8525C14.0839 21 14.2782 20.838 14.3059 20.622L14.6575 18.237C15.2219 18.012 15.74 17.706 16.2212 17.355L18.525 18.255C18.5806 18.273 18.6361 18.282 18.6916 18.282C18.8489 18.282 19.0062 18.201 19.0894 18.057L20.9399 14.943C21.051 14.745 21.0047 14.502 20.8289 14.367L18.8766 12.882ZM17.0909 12C17.0909 11.811 17.0817 11.622 17.0446 11.343L16.9151 10.326L17.7386 9.696L18.7286 8.931L18.0809 7.842L16.9059 8.301L15.9251 8.688L15.0831 8.058C14.713 7.788 14.3429 7.581 13.9451 7.419L12.9643 7.032L12.8163 6.015L12.6405 4.8H11.3544L11.1693 6.015L11.0213 7.032L10.0405 7.419C9.66117 7.572 9.28181 7.788 8.88396 8.076L8.05123 8.688L7.08898 8.31L5.91391 7.851L5.26624 8.94L6.26551 9.696L7.08898 10.326L6.95944 11.343C6.93168 11.613 6.91318 11.82 6.91318 12C6.91318 12.18 6.93168 12.387 6.95944 12.666L7.08898 13.683L6.26551 14.313L5.26624 15.069L5.91391 16.158L7.08898 15.699L8.06974 15.312L8.91172 15.942C9.28181 16.212 9.65191 16.419 10.0498 16.581L11.0305 16.968L11.1786 17.985L11.3544 19.2H12.6497L12.8348 17.985L12.9828 16.968L13.9636 16.581C14.3429 16.428 14.7223 16.212 15.1201 15.924L15.9529 15.312L16.9151 15.69L18.0902 16.149L18.7378 15.06L17.7386 14.304L16.9151 13.674L17.0446 12.657C17.0724 12.387 17.0909 12.189 17.0909 12Z"
          fill="#3e914a"
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
          fill="#3e914a"
        />
      </svg>
    ),
    isMobileOnly: false,
  },
]

export default mainSidebarMenu
